import { Component, OnInit } from '@angular/core';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { User_Interface } from 'src/app/Interface/User_Interface';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { UserService } from 'src/app/Service/User/User.service';


@Component({
  selector: 'app-UserError',
  templateUrl: './UserError.component.html',
  styleUrls: ['./UserError.component.scss']
})
export class UserErrorComponent implements OnInit {
  Selected_User_Id:String="0"
  page=0

  Procssing:boolean=false



  constructor(
    private User_Service:UserService,
    private Nav_Service:NavService,
  ) { }


  DataList_User:Array<General_Interface>=[]


  ngOnInit() {

    this.Nav_Service.CheckValidPage(2213).subscribe(
      data=>{

      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }



  ReadData_User(StartSearchDate,EndSearchDate){
    this.Procssing=true
    this.User_Service.GetError(StartSearchDate,EndSearchDate).subscribe(
      data=>{
        this.DataList_User=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }
}
